import { Input, Tooltip } from 'antd';
import s from './style.module.scss';
import { defaultPlaceholder, plugin_json, defaultSkill, newChatImg, sendButtonImg, pauseButtonImg, third_json_handler } from '@/utils/Page/constant';
import MyIcon from '@/components/MyIcon';
import { useWebSender } from '../../hooks/useWebSender';
import { cloneDeep } from 'lodash';
import React, { useEffect, useRef, useState, useMemo } from 'react';
import SkillTemplate from './SkillTemplate';
import { Display } from '@/components/Display/Display';
import ToastUtils from '@/utils/ToastUtils';
import { useJoin } from '@/libTTS/useCommon';
import aigcConfig from '@/configTTS';
import { getUserId } from '@/utils/Page';
import { agentSessionUpsertTTS, checkBusiness } from '@/api/grt/ai';
import PhoneOutlined from '@/assets/img/icon@2x.png';
import UsualSkillFileUpload from './UsualSkill/FileUpload';
import EvaluationUpload from './Review/EvalutionUpload';
import SenderFiles from './AgentFile/SenderFiles';
import WebReference from './WebReference';
import MultimodalReference from './MultimodalLearning/MultimodalReference';
import Config from '@/configTTS';
import { getFileStatus } from '@/utils/Page';
import { getSkillPluginNames } from '@/utils/Page';
import { pluginMap } from '@/utils/Page/constant';
import ChatTTS from '@/pages/Web/Outside/pages/chatTTS';
import { inject, observer } from 'mobx-react';
import grtStore from '@/store/grtStore';
const { TextArea } = Input;
const WebSender = (props) => {
    const { skillStore, chatStore } = props.store;
    const [visible, setVisible] = useState(false);
    const boxRef = useRef();
    const {
        curPlugin,
        setCurPlugin,
        isFileChatType,
        isTargetSkillType,
        curSkill,
        setCurSkill,
        originSkillList: skillListRef,
        curSkill: curSkillRef
    } = skillStore;
    const { authTest, references, setReferences, agentFile, setAgentFile } = chatStore;
    const {
        loading = false,
        plugins = [],
        themeColor = 1,
        editPlanMode = false,
        exitEditPlanMode,
        onStop,
        activeReportId,
        messages,
        sessionId,
        handleDeerFlowStop,
        stopHistoryPolling,
        handlePaste
    } = props;

    // multimodal reference is stored in global store; read from there so updates from hooks/stores show in sender
    const { multimodalStore } = grtStore;
    const multimodalReference = multimodalStore?.multimodalReference;
    const setMultimodalReference = multimodalStore?.setMultimodalReference;
    const [inFocus, setInFocus] = useState(false);
    const [curPluginIds, setCurPluginIds] = useState([]);
    // 判断是否为DeerFlow技能 - 🔥 移动到前面，确保在onSubmitValue中可以使用
    const isDeerFlow = curSkill?.third_json?.handler === 'deerflow';
    const isAippt = curSkill?.third_json?.handler === 'aippt';

    // 🔥 使用 useWebSender hook 管理暂停图标和状态
    const {
        showPauseIcon,
        setShowPauseIcon,
        isResearchTask,
        setIsResearchTask,
        isPauseClickable,
        setIsPauseClickable,
        aipptLoading,
        setAipptLoading,
        isSubmitting,
        setIsSubmitting,
        handleStop,
        lastSubmitTimeRef,
        submitTimeoutRef
    } = useWebSender({
        sessionId,
        isDeerFlow,
        isAippt,
        messages,
        activeReportId,
        handleDeerFlowStop,
        stopHistoryPolling,
        onStop
    });

    //输入框显示/隐藏
    const onSubmitValue = () => {
        // 🔥 新增：防抖处理 - 如果正在提交中或距离上次提交时间少于1秒，则忽略
        const currentTime = Date.now();
        if (isSubmitting || currentTime - lastSubmitTimeRef.current < 1000) {
            return false;
        }
        // 🔥 新增：输入验证逻辑 - 适用于所有模式
        if (isDeerFlow && (loading || !props.value || props.value.trim() === '')) {
            return false;
        }
        // 🔥 修改：如果是DeerFlow且已显示暂停图标，或者AIPPT加载中，阻止发送新消息
        if ((isDeerFlow && sessionId && showPauseIcon) || (isAippt && aipptLoading)) {
            return false;
        }

        // 🔥 新增：设置提交状态，防止重复提交
        setIsSubmitting(true);
        lastSubmitTimeRef.current = currentTime;

        // 🔥 修改：如果是DeerFlow模式，发送消息后立即显示暂停图标
        // 不依赖sessionId，因为第一次发送时sessionId可能还没有值
        if (isDeerFlow) {
            setShowPauseIcon(true); // 直接设置显示暂停图标
            setIsResearchTask(false); // 🔥 普通消息不是研究任务，暂停按钮不可点击
        }

        // 🔥 新增：发送消息时更新本地存储中会话的canPause状态为true
        if (sessionId) {
            try {
                const historySessionsStr = localStorage.getItem('grt_history_sessions');
                if (historySessionsStr) {
                    const historySessions = JSON.parse(historySessionsStr);
                    if (Array.isArray(historySessions)) {
                        // 找到对应的会话并更新canPause状态为true
                        const updatedSessions = historySessions.map((session) => {
                            if (session.sessionId === sessionId) {
                                return {
                                    ...session,
                                    canPause: true,
                                    isClickable: false, // 🔥 修复：普通消息时暂停按钮不可点击
                                    update_time: new Date().toISOString().replace('T', ' ').substring(0, 19)
                                };
                            }
                            return session;
                        });

                        // 保存更新后的数据
                        localStorage.setItem('grt_history_sessions', JSON.stringify(updatedSessions));
                    }
                }
            } catch (error) {
                console.error('🔥 发送消息时更新本地存储会话状态失败:', error);
            }
        }

        if (props.onSubmit) {
            try {
                // 支持将多模态引用随消息一起发送（如果存在 multimodalReference）
                const submitParam = { question: props.value };
                if (multimodalReference) {
                    submitParam.multimodal_reference = multimodalReference;
                    // 同步 reference_id 到顶层，兼容后端接收顶层 reference_id 的场景
                    if (multimodalReference.reference_id) {
                        submitParam.reference_id = multimodalReference.reference_id;
                    }
                }
                props.onSubmit(submitParam);
                // 如果在编辑计划模式下提交，自动退出编辑模式
                if (editPlanMode && exitEditPlanMode) {
                    setTimeout(() => {
                        exitEditPlanMode();
                    }, 100);
                }
            } catch (error) {
                console.error('🔥 提交消息时出错:', error);
            } finally {
                // 🔥 新增：无论成功还是失败，都要重置提交状态，避免卡死
                setTimeout(() => {
                    setIsSubmitting(false);
                }, 500); // 延迟500ms重置，确保不会立即重复提交
            }
        } else {
            // 🔥 新增：如果没有onSubmit函数，也要重置状态
            setIsSubmitting(false);
        }
    };

    //阻止发送的时候带换行符
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (e.shiftKey) {
                // 允许 Shift+Enter 换行（不阻止默认行为）
                return;
            }
            e.preventDefault();
            // onSubmitValue();
        }
    };
    const handleKeyUp = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (e.shiftKey) {
                // 允许 Shift+Enter 换行（不阻止默认行为）
                return;
            }

            // 🔥 修改：如果是DeerFlow且显示暂停图标，或者AIPPT加载中，直接返回不处理
            if ((isDeerFlow && sessionId && showPauseIcon) || (isAippt && aipptLoading)) {
                // DeerFlow模式下暂停状态时，或AIPPT加载中时，回车键不执行任何操作
                return;
            }

            // 🔥 新增：如果正在提交中，不处理Enter键
            if (isSubmitting) {
                return;
            }

            onSubmitValue();
        }
    };
    // const onPressEnter = (e) => {
    //     if (e.shiftKey) {
    //         return false;
    //     }
    //     e.preventDefault();
    //     onSubmitValue();
    // };
    const togglePlugin = (item) => {
        if (item.choice === 1) {
            return false;
        }
        let data = cloneDeep(curPlugin) || [];
        let index = data.findIndex((plugin) => plugin.code === item.code);
        if (index === -1) {
            data.push(item);
        } else {
            data.splice(index, 1);
        }

        if (setCurPlugin) {
            setCurPlugin(data);
        }
    };
    useEffect(() => {
        if (curPlugin) {
            let ids = curPlugin.map((item) => item.code);
            setCurPluginIds(ids);
        }
    }, [curPlugin]);

    // 监听会话切换和技能切换，自动退出修改方案模式
    useEffect(() => {
        if (editPlanMode && exitEditPlanMode) {
            exitEditPlanMode();
        }
    }, [activeReportId, curSkill]);

    //切换技能时重置插件
    const resetSKill = () => {
        // 这样可以确保使用后端返回的完整技能数据（包括 left_side 等属性）
        const generalSkill = skillListRef?.find((ele) => String(ele.ability_id) === '-1') || defaultSkill;
        setCurSkill(generalSkill);
    };
    const focus = () => {
        setInFocus(true);
    };
    const blur = () => {
        setInFocus(false);
    };

    const toggleShow = () => {
        setVisible(!visible);
    };

    const onCloseTemplate = () => {
        setVisible(false);
    };
    const setTemplate = (content) => {
        // onCloseTemplate();
        props.onChange(content);
    };
    const [joining, dispatchJoin] = useJoin();
    const username = aigcConfig.BaseConfig.UserId;
    const roomId = aigcConfig.BaseConfig.RoomId;
    const getImg = () => {
        let { inUpload, uploadSuccess } = getFileStatus(agentFile);

        // 🔥 修改：如果需要显示暂停图标（DeerFlow或AIPPT模式），始终显示暂停图标
        // 不依赖sessionId，因为第一次发送时sessionId可能还没有值
        if ((isDeerFlow && showPauseIcon) || (aipptLoading && showPauseIcon)) {
            return pauseButtonImg[themeColor];
        }
        // 🔥 新增：如果正在提交中，显示禁用状态
        if (isSubmitting) {
            return sendButtonImg[themeColor].disable;
        }
        if (loading && !isAippt) {
            return sendButtonImg[themeColor].loading;
        }
        if (inUpload.length) {
            return sendButtonImg[themeColor].disable;
        }
        if ((props.value && props.value.trim().length) || uploadSuccess.length) {
            return sendButtonImg[themeColor].send;
        }

        return sendButtonImg[themeColor].disable;
    };

    // 根据DeerFlow状态判断是否显示暂停按钮
    const shouldShowPauseButton = useMemo(() => {
        // 🔥 修改：显示暂停按钮的条件：
        // 1. DeerFlow模式下，显示暂停按钮的条件：
        //    - 是DeerFlow模式
        //    - 显式设置了showPauseIcon为true（基于localStorage中的canPause状态）
        // 2. AIPPT模式下，显示暂停按钮的条件：
        //    - AIPPT加载中且showPauseIcon为true
        return (isDeerFlow && showPauseIcon) || (aipptLoading && showPauseIcon);
    }, [isDeerFlow, showPauseIcon, aipptLoading]);

    // 判断暂停按钮是否可以点击
    const isPauseButtonClickable = useMemo(() => {
        // 🔥 修改：暂停按钮可点击性判断
        // 1. DeerFlow模式下：研究任务或localStorage中标记为可点击
        // 2. AIPPT模式下：不可点击（仅作为视觉指示器）
        if (aipptLoading) {
            return false; // AIPPT加载期间暂停按钮不可点击
        }

        if (!isDeerFlow) return false;

        // DeerFlow模式下的可点击性判断
        const clickable = isResearchTask || isPauseClickable;
        return clickable;
    }, [isDeerFlow, isResearchTask, isPauseClickable, aipptLoading]);

    // 🔥 判断发送按钮是否应该禁用
    const isSendButtonDisabled = useMemo(() => {
        // 如果显示暂停按钮，则不禁用（暂停按钮应该始终可点击）
        if (shouldShowPauseButton) {
            return false;
        }

        // 🔥 新增：如果正在提交中，禁用发送按钮
        if (isSubmitting) {
            return true;
        }

        // 输入内容为空
        if (isDeerFlow && (!props.value || props.value.trim() === '')) {
            return true;
        }

        return false;
    }, [props.value, shouldShowPauseButton, isSubmitting]);
    // const handlePaste = (e) => {
    //     if (agentFile.length === 0 && isFileChatType(curSkill?.ability_id)) {
    //         const pastedText = e.clipboardData.getData('text');
    //         if (isUrl(pastedText)) {
    //             setAgentFile([
    //                 {
    //                     file_url: pastedText,
    //                     type: fileTypeMap.link,
    //                     name: pastedText,
    //                     status:2
    //                 }
    //             ]);
    //             e.preventDefault(); // 阻止粘贴
    //             return;
    //         }
    //     }
    // };
    const isAiReview = () => {
        if (!isTargetSkillType || !curSkill) {
            return false;
        }

        return isTargetSkillType(curSkill?.ability_id, third_json_handler.ai_evaluation);
    };
    return (
        <div className={s['web-send-wrap']} ref={boxRef} data-focus={inFocus}>
            <SkillTemplate
                setTemplate={setTemplate}
                templateList={curSkill?.ability_template_list}
                onClose={onCloseTemplate}
                visible={visible}
            ></SkillTemplate>

            <Display show={agentFile.length}>
                {/* <AgentFile from="sender" needParse={true} fileList={agentFile} setAgentFile={setAgentFile}></AgentFile> */}
                <SenderFiles from="sender" needParse={isAiReview() ? false : true} fileList={agentFile} setAgentFile={setAgentFile}></SenderFiles>
            </Display>
            <Display show={references.length}>
                <WebReference
                    isTargetSkillType={isTargetSkillType}
                    curSkill={curSkill}
                    setReferences={setReferences}
                    files={references}
                ></WebReference>
            </Display>
            <Display show={multimodalReference}>
                <MultimodalReference
                    data={multimodalReference}
                    from="sender"
                    onClose={() => setMultimodalReference && setMultimodalReference(null)}
                    onListClick={multimodalReference?.onListClick}
                />
            </Display>

            <div className={s['text-area-wrap']}>
                {/* 🔥 修复：只有当 left_side 为 1 时才显示技能标签（已下架的技能 left_side 为 0） */}
                <Display show={curSkill?.ability_id && curSkill?.ability_id != -1}>
                    <div className={s['skill-tag']}>
                        <span className={s['skill-name']}> {curSkill?.ability_name}</span>
                        <Display show={curSkill?.left_side === 2}>
                            <span onClick={resetSKill} className={s['close-icon']}>
                                <MyIcon style={{ fontSize: '10px' }} type="icon-a-guanbi31"></MyIcon>
                            </span>
                        </Display>
                    </div>
                </Display>

                {/* 修改计划模式标签 */}
                <Display show={editPlanMode}>
                    <div
                        className={s['skill-tag']}
                        style={{
                            marginLeft: '10px'
                        }}
                    >
                        <span className={s['skill-name']}>修改方案</span>
                        <span
                            onClick={() => {
                                if (typeof exitEditPlanMode === 'function') {
                                    exitEditPlanMode();
                                }
                            }}
                            className={s['close-icon']}
                        >
                            <MyIcon style={{ fontSize: '10px' }} type="icon-a-guanbi31"></MyIcon>
                        </span>
                    </div>
                </Display>

                <TextArea
                    onPaste={handlePaste}
                    id={'web-send-input'}
                    onFocus={focus}
                    onBlur={blur}
                    autoSize={{ minRows: 2, maxRows: 5 }}
                    onKeyUp={handleKeyUp}
                    // onPressEnter={onPressEnter}

                    onKeyDown={handleKeyDown}
                    value={props.value}
                    placeholder={props.placeholder || curSkill?.default_prompt}
                    onChange={(e) => {
                        props.onChange(e.target.value);
                    }}
                />
            </div>

            <div className={s['bottom']}>
                <div className={s['plugin-wrap']}>
                    <Display show={isTargetSkillType && isTargetSkillType(curSkill?.ability_id, third_json_handler.ai_evaluation)}>
                        <EvaluationUpload agentFile={agentFile} setAgentFile={setAgentFile}></EvaluationUpload>
                    </Display>
                    <Display show={typeof isFileChatType === 'function' && isFileChatType(curSkill?.ability_id)}>
                        <UsualSkillFileUpload
                            setReferences={setReferences}
                            agentFile={agentFile}
                            setAgentFile={setAgentFile}
                            authTest={authTest}
                        ></UsualSkillFileUpload>
                    </Display>
                    <Display show={curSkill?.ability_template_list && curSkill?.ability_template_list.length}>
                        <Tooltip title={'模板'}>
                            <div
                                data-type={'template'}
                                data-checked={visible}
                                className={s['plugin-item']}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleShow();
                                }}
                            >
                                <MyIcon type={'icon-a-moban'}></MyIcon>
                            </div>
                        </Tooltip>
                    </Display>

                    {plugins.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <Display show={item.code === 1 && item.choice !== 1}>
                                    <div
                                        data-checked={item.choice === 1 || curPluginIds.includes(item.code)}
                                        onClick={() => {
                                            togglePlugin(item);
                                        }}
                                        className={s['plugin-item']}
                                        key={index}
                                    >
                                        <MyIcon className={s['plugin-icon']} type={plugin_json[item.code].type}></MyIcon>
                                        <span>{plugin_json[item.code].name}</span>
                                    </div>
                                </Display>
                                <Display show={item.code === 0}>
                                    <div
                                        data-checked={item.choice === 1 || curPluginIds.includes(item.code)}
                                        data-choice={item.choice}
                                        onClick={() => {
                                            togglePlugin(item);
                                        }}
                                        className={s['plugin-item']}
                                        key={index}
                                    >
                                        <MyIcon className={s['plugin-icon']} type={plugin_json[item.code].type}></MyIcon>
                                        <span> {item.choice === 1 ? `${plugin_json[item.code].name}：开` : plugin_json[item.code].name}</span>
                                    </div>
                                </Display>
                            </React.Fragment>
                        );
                    })}
                </div>
                <div className={s['action-wrap']}>
                    <Display show={props.startNewSession}>
                        <div onClick={props.startNewSession} className={s['new-chat-wrap']}>
                            <img src={newChatImg[themeColor]} alt="" />
                            <span>开启新对话</span>
                        </div>
                        <Display
                            show={curSkill?.plugin_json?.length > 0 && getSkillPluginNames(curSkill?.plugin_json).includes(pluginMap.voice_call)}
                        >
                            <ChatTTS {...props} />
                        </Display>
                    </Display>
                    {/* 🔥 改进：分别处理暂停按钮和发送按钮，逻辑更清晰 */}
                    {shouldShowPauseButton ? (
                        <img
                            className={`${s['send-img']} ${!isPauseButtonClickable ? s['send-img-disabled'] : ''}`}
                            onClick={
                                isPauseButtonClickable
                                    ? () => {
                                          handleStop();
                                      }
                                    : () => {
                                          if (aipptLoading) {
                                          }
                                      }
                            }
                            src={getImg()}
                            alt=""
                            style={{
                                cursor: isPauseButtonClickable ? 'pointer' : 'not-allowed'
                            }}
                        />
                    ) : (
                        <img
                            className={`${s['send-img']} ${isSendButtonDisabled ? s['send-img-disabled'] : ''}`}
                            onClick={
                                isSendButtonDisabled
                                    ? undefined
                                    : () => {
                                          onSubmitValue();
                                      }
                            }
                            src={getImg()}
                            alt=""
                            style={{
                                cursor: isSendButtonDisabled ? 'not-allowed' : 'pointer'
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default inject('store')(observer(WebSender));
